// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.project-avatar {
  color: var(--color-avatar-foreground);
}
.project-avatar--size-xxxl {
  height: 48px;
  width: 48px;
}
.project-avatar--size-xl {
  height: 32px;
  width: 32px;
}
.project-avatar--size-md {
  height: 16px;
  width: 16px;
}
.project-avatar--withBackground {
  background: var(--color-avatar-background);
}
.project-avatar--radius-xs {
  border-radius: 4px;
}
.project-avatar--radius-sm {
  border-radius: 8px;
}
.project-avatar--radius-md {
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/project/ui/project-avatar/ProjectAvatar.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EAEE,qCAAA;AAQF;AALI;EACE,YAAA;EACA,WAAA;AAON;AAJI;EACE,YAAA;EACA,WAAA;AAMN;AAHI;EACE,YAAA;EACA,WAAA;AAKN;AADE;EACE,0CAAA;AAGJ;AAAE;EACE,kBAAA;AAEJ;AACE;EACE,kBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.project-avatar {\n\n  color: var(--color-avatar-foreground);\n\n  &--size {\n    &-xxxl {\n      height: @layoutUnit-xxxl;\n      width: @layoutUnit-xxxl;\n    }\n\n    &-xl {\n      height: @layoutUnit-xl;\n      width: @layoutUnit-xl;\n    }\n\n    &-md {\n      height: @layoutUnit-md;\n      width: @layoutUnit-md;\n    }\n  }\n\n  &--withBackground {\n    background: var(--color-avatar-background);\n  }\n\n  &--radius-xs {\n    border-radius: @layoutUnit-xs;\n  }\n\n  &--radius-sm {\n    border-radius: @layoutUnit-sm;\n  }\n\n  &--radius-md {\n    border-radius: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
